module.exports = __webpack_public_path__ + "media/images/empty/alert-7f169ca5e66da996a744d9264e5ea2bc.svg";